/* Revives interactivity on the ripped legacy pages (accordions, testimonial
   carousel, filterable reviews). Pure front-end — no Shopify data needed.
   Defensive: every block no-ops if its markup isn't on the page. */
(function () {
  "use strict";
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    try { accordions(); } catch (e) { console.warn("accordion", e); }
    try { testimonialCarousel(); } catch (e) { console.warn("carousel", e); }
    try { ggrsReviews(); } catch (e) { console.warn("ggrs", e); }
  });

  /* ---- Accordions: <details> toggles its sibling .accordion__content-wrapper ---- */
  function accordions() {
    var list = document.querySelectorAll("details.accordion__details");
    Array.prototype.forEach.call(list, function (d) {
      var wrap = d.nextElementSibling;
      while (wrap && !(wrap.classList && wrap.classList.contains("accordion__content-wrapper")))
        wrap = wrap.nextElementSibling;
      if (!wrap) return;
      var sync = function () { wrap.style.display = d.open ? "block" : "none"; };
      sync();
      d.addEventListener("toggle", sync);
    });
  }

  /* ---- Testimonial carousel: arrows + dots + touch swipe ---- */
  function testimonialCarousel() {
    var track = document.querySelector(".reviews-carousel");
    if (!track) return;
    var wrap = track.closest(".reviews-carousel-wrap") || track.parentElement;
    var cards = track.querySelectorAll(".review-card");
    if (!cards.length) return;
    var prev = document.getElementById("reviewsPrev");
    var next = document.getElementById("reviewsNext");
    var dotsWrap = document.getElementById("reviewsDots");
    var dots = dotsWrap ? dotsWrap.querySelectorAll("span") : [];
    var index = 0;

    function metrics() {
      var s = getComputedStyle(track);
      var gap = parseFloat(s.columnGap || s.gap) || 0;
      var cardW = cards[0].getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.round(wrap.getBoundingClientRect().width / cardW));
      return { cardW: cardW, maxIdx: Math.max(0, cards.length - perView) };
    }
    function go(i) {
      var m = metrics();
      index = Math.max(0, Math.min(i, m.maxIdx));
      track.style.transform = "translateX(" + (-index * m.cardW) + "px)";
      Array.prototype.forEach.call(dots, function (d, di) {
        d.classList.toggle("active", di === Math.min(index, dots.length - 1));
      });
    }
    if (prev) prev.addEventListener("click", function () { go(index - 1); });
    if (next) next.addEventListener("click", function () { go(index + 1); });
    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-index"), 10) || 0); });
    });
    var x0 = null;
    track.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    window.addEventListener("resize", function () { go(index); });
    go(0);
  }

  /* ---- Filterable review grid (ggrs) ---- */
  function ggrsReviews() {
    var cards = Array.prototype.slice.call(document.querySelectorAll("article.ggrs-card"));
    if (!cards.length) return;
    var grid = cards[0].parentNode;
    var starChips = document.querySelectorAll(".ggrs-chip[data-star]");
    var tagChips = document.querySelectorAll(".ggrs-chip[data-tag]");
    var sortSel = document.getElementById("ggrs-sort");
    var loadMore = document.getElementById("ggrs-load-more");
    var PAGE = 6;
    var state = { star: "all", tag: "all", sort: sortSel ? sortSel.value : "helpful", shown: PAGE };

    cards.forEach(function (c, i) {
      var el = c.querySelector(".ggrs-stars");
      var r = 0;
      if (el) {
        var m = (el.getAttribute("aria-label") || "").match(/(\d+(?:\.\d+)?)\s*out of/i);
        r = m ? parseFloat(m[1]) : (el.textContent.match(/★/g) || []).length;
      }
      c._rating = r;
      c._order = i;
      c._tags = Array.prototype.map.call(c.querySelectorAll(".ggrs-tag"), function (t) {
        return t.textContent.trim().toLowerCase();
      });
    });

    function render() {
      var list = cards.filter(function (c) {
        var okStar = state.star === "all" || Math.round(c._rating) === parseInt(state.star, 10);
        var okTag = state.tag === "all" || c._tags.indexOf(String(state.tag).toLowerCase()) > -1;
        return okStar && okTag;
      });
      list.sort(state.sort === "highest"
        ? function (a, b) { return b._rating - a._rating || a._order - b._order; }
        : function (a, b) { return a._order - b._order; });
      cards.forEach(function (c) { c.style.display = "none"; });
      list.forEach(function (c, i) { if (i < state.shown) { c.style.display = ""; grid.appendChild(c); } });
      if (loadMore) loadMore.style.display = list.length > state.shown ? "" : "none";
    }
    function activate(nodes, el) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.remove("active"); });
      if (el) el.classList.add("active");
    }
    Array.prototype.forEach.call(starChips, function (ch) {
      ch.addEventListener("click", function () {
        state.star = ch.getAttribute("data-star") || "all"; state.shown = PAGE; activate(starChips, ch); render();
      });
    });
    Array.prototype.forEach.call(tagChips, function (ch) {
      ch.addEventListener("click", function () {
        state.tag = ch.getAttribute("data-tag") || "all"; state.shown = PAGE; activate(tagChips, ch); render();
      });
    });
    if (sortSel) sortSel.addEventListener("change", function () { state.sort = sortSel.value; render(); });
    if (loadMore) loadMore.addEventListener("click", function () { state.shown += PAGE; render(); });
    render();
  }
})();
